(function () {
  const MATCH = new Set([
    "White Colorblast (Single Color)",
    "Black Colorblast (Single Color)"
  ]);

  function getCardDesign() {
    // Your Card Design is option1 in variant-selects (from your page source)
    const sel = document.querySelector("variant-selects select");
    return (sel?.value || "").trim();
  }

  function toggleColorblast() {
    const wrap = document.getElementById("ColorblastColorWrapper");
    const sel = document.getElementById("ColorblastColor");
    if (!wrap || !sel) return;

    const design = getCardDesign();
    const show = MATCH.has(design);

    wrap.style.display = show ? "" : "none";
    sel.required = show;
    if (!show) sel.value = "";
  }

  document.addEventListener("DOMContentLoaded", toggleColorblast);

  // When the Card Design dropdown changes
  document.addEventListener("change", (e) => {
    if (e.target.closest("variant-selects")) toggleColorblast();
  });

  // Dawn sometimes fires this event on variant updates
  document.addEventListener("variant:change", toggleColorblast);
})();
document.addEventListener("change", function (e) {
  if (e.target.id === "ColorblastColor") {
    const hidden = document.getElementById("ColorblastColorProperty");
    if (hidden) {
      hidden.value = e.target.value || "";
    }
  }
});
